import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { Options } from '@angular-slider/ngx-slider';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { InfosComponent } from '../dialogs/infos/infos.component';
import { MatDialog } from '@angular/material/';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';
import { PdfDialogComponent } from '../dialogs/pdf-dialog/pdf-dialog.component';
import { InfosPrixComponent } from '../dialogs/infos-prix/infos-prix';

@Component({
  selector: 'app-formes',
  templateUrl: './formes.component.html',
  styleUrls: ['./formes.component.scss']
})
export class FormesComponent extends WizardHpBaseComponent implements OnInit {
  @ViewChild('slider', { static: false }) hauteurView;
  @ViewChild('slider', { static: false }) largeurView;


  public product: any;
  public wPorte!: number;
  public hPorte!: number;
  hauteurValue: number;
  largeurValue: number;
  hauteurImposteValue: number;
  largeurTierceGValue: number;
  largeurTierceDValue: number;
  answers: any;
  questions: any;
  catId: any;
  prodId;
  etape_show = false;
  autoTicks = false;
  disabled = false;
  invert = false;
  max = 159;
  min = 45;
  showTicks = false;
  step = 1;
  thumbLabel = false;
  vertical = false;
  tickInterval = 1;
  value = 0;
  hauteurSize: number;
  largeurSize: number;
  refLargeurSize;
  refHauteurSize;
  event_largeur = true;
  event_hauteur = true;
  event_hauteurImposte = true;
  event_largeurTierceG = true;
  event_largeurTierceD = true;
  answerProgress = false;
  submitted = false;
  has_impost = false;
  popErro_visible = false;
  hauteurOptions: Options = {
    floor: 100,
    ceil: 0,
    showSelectionBar: true,
    vertical: true

  };
  largeurOptions: Options = {
    floor: 100,
    ceil: 0,
    showSelectionBar: true

  };
  dimensionForm: FormGroup
  maxLargeurFormControl: FormControl;
  
  var_min_l = 200;
  var_max_l = 2000;
  var_min_h = 500;
  var_max_h = 3000;
  
  var_min_imp = null;
  var_max_imp = null;
  var_min_tg = null;
  var_max_tg = null;
  var_min_td = null;
  var_max_td = null;

  forme_selected = 1;
  forme_refp = "SIMPLE";
  currentForme : any;
  cheminImageForme: any = "assets/images/formes/";

  formes = [ ];

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router, public fb: FormBuilder,
    public dialog: MatDialog) {
      super(chgDetectorRef, hpService, router);

    if (!this.getHpService().currentProductValue) {
      this.getRouter().navigate([this.getHpService().getConfig().herculepro.slug]);
    }
   
    this.product = this.getHpService().getGlobaldata();
    this.catId = this.getHpService().currentProductValue.catId;
    this.prodId = this.getHpService().currentProductValue.id;
    
    this.assignVariables();
    this.formes = this.getHpService().getConfig().herculepro.formes;
    this.forme_selected = this.getHpService().getFormeId();
    this.getHpService().setHeaderIn(true);
    this.getHpService().setEtape_final(false);
    this.getHpService().setCurrentPage(this.getIndexNextUrl('dimensions'))
  }


  assignVariables() {

    if (this.getHpService().getGlobalVars() != null) {
      this.largeurValue = parseInt(this.getHpService().getWidth());
      this.hauteurValue = parseInt(this.getHpService().getHeight());
      this.largeurSize = this.getHpService().getWidth();
      this.hauteurSize = this.getHpService().getHeight();
    }
    this.hauteurImposteValue = parseInt(this.getVariableValue('IMP'));
    this.largeurTierceGValue = parseInt(this.getVariableValue('TG'));
    this.largeurTierceDValue = parseInt(this.getVariableValue('TD'));

    if (this.getHpService().getGlobalVars() != null) {

      this.var_min_l = this.getHpService().getWidthMini();
      this.var_max_l = this.getHpService().getWidthMaxi();
      this.var_min_h = this.getHpService().getHeightMini();
      this.var_max_h = this.getHpService().getHeightMaxi();
      this.var_max_imp = this.getVariableMax('IMP');
      this.var_min_imp = this.getVariableMin('IMP');

      this.var_min_tg = this.getVariableMin('TG');
      this.var_max_tg = this.getVariableMax('TG');
      this.var_min_td = this.getVariableMin('TD');
      this.var_max_td = this.getVariableMax('TD');
    }

  }

  getVariable(name) {

    var result = null;
    if(this.getHpService().getOvConfigCat() != null) {
      var o = this.getHpService().getOvConfigCat().productPreconfig.by_default.variables[name];

      if (o != null) {
        var grpId = null;
        var qstId = null;
        var ansId = null;
        var varId = null;

        if (Object.prototype.toString.call(o).indexOf('String') > -1) {
          varId = o;
        } else {
          grpId = o.grpId;
          if (grpId.indexOf('{{product_code}}') > -1) {
            var prodCode = this.getHpService().getRootProductId();
            grpId = grpId.replace(/{{product_code}}/gi, prodCode);
          }
          qstId = o.qstId;
          ansId = o.ansId;
          varId = o.varId;
        }

        result = {
          grpId : grpId,
          qstId : qstId,
          ansId : ansId,
          varId : varId
        }
      }
    }
    return result;
  }

  getVariableMax(name) {
    var variable = this.getVariable(name);
    if (variable != null
          && variable.grpId != null && variable.qstId != null && variable.varId != null) {
      return this.getHpService().getVariableMax(variable.grpId, variable.qstId, variable.varId);
    }
    return null;
  }

  getVariableMin(name) {
    var variable = this.getVariable(name);
    if (variable != null
          && variable.grpId != null && variable.qstId != null && variable.varId != null) {
      return this.getHpService().getVariableMin(variable.grpId, variable.qstId, variable.varId);
    }
    return null;
  }

  getVariableValue(name) {
    var variable = this.getVariable(name);
    if (variable != null
          && variable.grpId != null && variable.qstId != null && variable.varId != null) {
      return this.getHpService().getVariableProperty(variable.grpId, variable.qstId, variable.varId, 'var_value');
    }
    return null;
  }

  ngOnInit() {

    this.assignVariables();
    this.refLargeurSize = document.getElementById('largeur-input') as HTMLInputElement;
    this.refHauteurSize = document.getElementById('hauteur-input') as HTMLInputElement;
    this.popErro_visible = !(this.getConfigIsValid());
    this.inputFocusIn = false;
    
  }

  buildForm() {
    const controlArray = this.dimensionForm.get('formArrayName') as FormArray;

    Object.keys(this.formes).forEach((i) => {
      controlArray.push(
        this.fb.group({
          largeur: [this.largeurValue, [Validators.min(this.var_min_l), Validators.max(this.var_max_l), Validators.required]],
          hauteur: [this.hauteurValue, [Validators.min(this.var_min_h), Validators.max(this.var_max_h), Validators.required]]
        })
      )
    })

   
  }


  getValidator() {
    return this.dimensionForm.invalid;
  }

  get f() { return this.dimensionForm.controls; }
  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }

  findIndexByPropertyValue(variable: any, var_dim_code: string) {
    const found = (element) => element.var_dim_code === var_dim_code;
    return (variable.findIndex(found));

  }

  getWidth() {
    return this.largeurSize;
  }

  getHeight() {
    return this.hauteurSize;
  }

  getHeightImposte() {
    if (isNaN(this.hauteurImposteValue)) {
      return '';
    }
    return this.hauteurImposteValue;
  }

  getWidthTierceG() {
    if (isNaN(this.largeurTierceGValue)) {
      return '';
    }
    return this.largeurTierceGValue;
  }

  getWidthTierceD() {
    if (isNaN(this.largeurTierceDValue)) {
      return '';
    }
    return this.largeurTierceDValue;
  }


  getSliderTickInterval(): number | 'auto' {
    if (this.showTicks) {
      return this.autoTicks ? 'auto' : this.tickInterval;
    }

    return 0;
  }
  public getglobalData(): any {
    return this.getHpService().getGlobaldata();
  }

  getConfigIsValid() {
    let valueDefined =    (this.largeurValue === undefined && this.hauteurValue === undefined) ||
                          (this.hauteurValue === undefined && this.largeurValue === undefined && this.hauteurImposteValue === undefined ) ||
                          (this.largeurValue === undefined && this.hauteurValue === undefined &&  this.largeurTierceGValue  === undefined) ||
                          (this.largeurValue === undefined && this.hauteurValue === undefined &&  this.largeurTierceDValue  === undefined) ||   
                          (this.largeurValue === undefined && this.hauteurValue === undefined &&  this.largeurTierceGValue  === undefined && this.hauteurImposteValue === undefined)||
                          (this.largeurValue === undefined && this.hauteurValue === undefined &&  this.largeurTierceDValue  === undefined && this.hauteurImposteValue === undefined) ||
                          (this.largeurValue === undefined && this.hauteurValue === undefined && this.largeurTierceGValue  === undefined && this.largeurTierceDValue  === undefined && this.hauteurImposteValue === undefined)||
                          (this.getHeightImposte() === null && this.has_impost)
            
                       
   let configForme =  (this.parseToFloatInt(this.var_min_h) > this.hauteurValue  || this.hauteurValue > this.parseToFloatInt(this.var_max_h)) ||
                      (this.parseToFloatInt(this.var_min_l) > this.largeurValue   || this.largeurValue > this.parseToFloatInt(this.var_max_l)) ||
                      (this.parseToFloatInt(this.var_min_imp) > this.hauteurImposteValue)  ||
                      (this.parseToFloatInt(this.var_max_imp) < this.hauteurImposteValue)  ||
                      (this.parseToFloatInt(this.var_min_tg) > this.largeurTierceGValue)  ||
                      (this.largeurTierceGValue > this.parseToFloatInt(this.var_max_tg)) ||
                      (this.parseToFloatInt(this.var_min_td) > this.largeurTierceDValue) || 
                      (this.largeurTierceDValue > this.parseToFloatInt(this.var_max_td)) 
                      
                      this.getHpService().setStatutMatButton(configForme ||  valueDefined);

    return !(configForme ||  valueDefined) ;
  }
/**
 * 
 * @returns check dimension
 */
checkDimension(name) {

  switch(name){

    case "H":
      return (this.parseToFloatInt(this.var_min_h) >  this.parseToFloatInt(this.hauteurValue))  || (this.parseToFloatInt(this.hauteurValue) > this.parseToFloatInt(this.var_max_h))

    case "L":
             return (this.parseToFloatInt(this.var_min_l) > this.parseToFloatInt(this.largeurValue) )  || (this.parseToFloatInt(this.largeurValue) > this.parseToFloatInt(this.var_max_l))
   
    case "IMP":
             return (this.parseToFloatInt(this.var_min_imp) > this.parseToFloatInt(this.hauteurImposteValue)   || this.parseToFloatInt(this.hauteurImposteValue) > this.parseToFloatInt(this.var_max_imp))
    case "TG":
              return (this.parseToFloatInt(this.var_min_tg) > this.parseToFloatInt(this.largeurTierceGValue)   || this.parseToFloatInt(this.largeurTierceGValue) > this.parseToFloatInt(this.var_max_tg))
        
    case "TD":
       return this.parseToFloatInt(this.var_min_td) > this.parseToFloatInt(this.largeurTierceDValue) || this.parseToFloatInt(this.largeurTierceDValue) > this.parseToFloatInt(this.var_max_td)
 
            }


}

  goToSimulateur() {
    
    this.popErro_visible = !(this.getConfigIsValid());
    if( this.popErro_visible)
    {
      
      return;
    }
    this.getHpService().setCurrentPage(this.getIndexNextUrl('simulateur-de-portes'));
    this.getRouter().navigate(['simulateur-de-portes']);
  }

  openAideMesure(via: string) {

    this.getHpService().setStatut_user(false);
    this.closeMesg();
    const dialogRef = this.dialog.open(InfosPrixComponent, {
      panelClass: 'full-width-dialog-info-price',
      backdropClass: "dimension-dialog-background",
      hasBackdrop: true,
      autoFocus: false,
      data: { via: via }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }

  getUrlapi() {
    return this.getHpService().getUrlapi();
  }

  selectForme(id, has_impost) {
  
    this.has_impost = has_impost ;
    this.currentForme = this.getFormById(id);
    if (this.getHpService().getOvConfigCat() != null 
            && (this.forme_selected == null || this.forme_selected != id)) {

      var t = this.getHpService().getOvConfigCat();
      if (t.productPreconfig != null && t.productPreconfig.by_default != null) {

        var defaults = t.productPreconfig.by_default;

        var form = this.getFormById(id);

        var allActions = [];
        var formLib = '';
        if (form) {
            
          if (defaults['SYS.NO_FORM'] != null
                && defaults['SYS.NO_FORM'].length > 0) {
                  formLib += 'SYS.NO_FORM,';
          }

          if (form.imposte == true && defaults['SYS.IMPOSTE'] != null
                  && defaults['SYS.IMPOSTE'].length > 0) {
                    formLib += 'SYS.IMPOSTE,';
          }
          
          if (form.tierce_g == true && defaults['SYS.TIERCE.G'] != null
                  && defaults['SYS.TIERCE.G'].length > 0) {
                    formLib += 'SYS.TIERCE.G,';
          }

          if (form.tierce_d == true && defaults['SYS.TIERCE.D'] != null
                  && defaults['SYS.TIERCE.D'].length > 0) {
                    formLib += 'SYS.TIERCE.D,' ;
          }
        }

        if (formLib != '') {
          formLib = formLib.substring(0, formLib.length -1);
          this.getHpService().setAppLoader(true);
          this.getHpService().autoPositionActions(formLib, this.assignVariables, this);
        }
      }
    }

    this.forme_selected = id;
    this.getHpService().setFormeId(id);
    this.getHpService().emitDataChange();
  }

  
  getFormById(formId) {

    for (var i = 0; i < this.formes.length; i++) {
      if (this.formes[i].id == formId) {
        return this.formes[i];
      }
    }
  }

  updateVarValue (name, value) {
    debugger;
    /*
    if(!this.getConfigIsValid() && !(this.currentForme.tierce_g || this.currentForme.tierce_d))  {
      return;
    }
    */
   var result = null;
    if(this.getHpService().getOvConfigCat() != null) {
      var o = this.getHpService().getOvConfigCat().productPreconfig.by_default.variables[name];
      if (o != null) {

        var qstId = null;
        var ansId = null;
        var varId = null;

        if (Object.prototype.toString.call(o).indexOf('String') > -1) {
          varId = o;
        } else {
          qstId = o.qstId;
          ansId = o.ansId;
          varId = o.varId;
        } 
        this.getHpService().setIsLoading(true);
        this.getHpService().setAppLoader(true);
        this.getHpService().putVariablesValues(
          this.getHpService().getCatId(), this.getHpService().getRootProductId(), 
          this.getHpService().getRootProductElt(), qstId, ansId, varId, value).subscribe(data => {

          this.getHpService().setGlobaldata(data);
           this.assignVariables();
          this.resetFormeT_imposte();
          
          this.getHpService().setIsLoading(false);
          this.getHpService().setAppLoader(false);
      });   
      
      
      }
    }

  }
  change(name, event) {
    this.inputFocusIn =false;
    console.log (event.target.value)
  
    let patt = new RegExp('^-?[0-9]\\d*(\\.\\d{1,2})?$');
    var val = event.target.value;
    if (name == 'L') {

      if (this.largeurValue != val) {
        this.largeurValue = val;
        this.updateVarValue(name, val);
      }

    } else if (name == 'H') {

      if (this.hauteurValue != val) {
         
        
        this.hauteurValue = val;
        this.updateVarValue(name, val);
      }

    } else if (name == 'IMP') {

       if (this.hauteurImposteValue != val) {
        this.hauteurImposteValue = val;
        console.log(this.hauteurImposteValue)
        this.updateVarValue(name, val);
         }

    } else if (name == 'TG') {

      if (this.largeurTierceGValue != val) {
        
        this.largeurTierceGValue = val;
        this.updateVarValue(name, val);
      }
    } else if (name == 'TD') {

      if (this.largeurTierceDValue != val) {
        this.largeurTierceDValue = val;
        this.updateVarValue(name, val);
      }
    }
  }

 resetFormeT_imposte() {

  var idforme= this.forme_selected;
  
  switch(true){
    case (this.getHeightImposte() === null && this.has_impost && !this.currentForme.tierce_g && !this.currentForme.tierce_g):
      this.updateVarValue("L", this.var_min_l);
      this.forme_selected = -1;
      this.selectForme(idforme, true)       
        break;
    case (this.getHeightImposte() === null && this.has_impost && this.currentForme.tierce_g && this.currentForme.tierce_g):
      this.updateVarValue("TG", this.var_min_tg);
      this.updateVarValue("TD", this.var_min_td);
      this.forme_selected = -1;
      this.selectForme(idforme, true)       
        break;    
    case (this.getHeightImposte() === null && this.has_impost && this.currentForme.tierce_g):
      this.updateVarValue("TG", this.var_min_tg);
      this.forme_selected = -1; 
      this.selectForme(idforme, true)  
        break;
    case (this.getHeightImposte() === null && this.has_impost && this.currentForme.tierce_d):
          this.updateVarValue("TD", this.var_min_td);
          this.forme_selected = -1; 
          this.selectForme(idforme, true)    
        break;   
  }

  }


  parseToInt(val) {
    return parseInt(val);
  }

  parseToFloatInt(val)
  {
     return Math.floor(parseFloat(val));
  }

 isNumber(val)
  {
  return isNaN(val);

  }

  getProductForme(item: any) {

    switch (true) {
      case item === "SIMPLE":
        this.forme_refp = "b";
        return "forme-simple";
      case item === "SIMPLE-IMPOSTE":
        return "forme-simple-imposte dimension-forme-imposte"
      case item === "TIERCE-G":
        return "forme-tierce-g";
      case item === "TIERCE-D":
        return "forme-tierce-d";
      case item === "TIERCE-GD":
        return "forme-tierce-gd";
      case item === "TIERCE-G-IMPOSTE":
        return "forme-tierce-g-imposte dimension-forme-imposte";
      case item === "TIERCE-D-IMPOSTE":
        return "forme-tierce-d-imposte dimension-forme-imposte";
      case item === "TIERCE-GD-IMPOSTE":
        return "forme-tierce-gd-imposte dimension-forme-imposte";
      default:
        return "forme-simple";

    }

  }

  closeMesg()
  {
    this.popErro_visible = false;
   
  }
  inputFocusIn = false;
  disableButton()
  {
       this.inputFocusIn = true;
   
  }



}
